<!--
     DO NOT TOUCH THIS FILE UNLESS YOU CAN 100% CONFIRM EVERYTHING IS WORKING

     return value to parent modal will be determined by inputType
-->
<script setup>
import { ref } from "vue";
const props = defineProps({
  modelValue: [String, Number],
  modelModifiers: { default: () => ({}) },
  isPercentage: Boolean,
  inputType: String,
  isWhole: Boolean,
  placeholder: String,
  customClass: Object,
});

const emit = defineEmits(["update:modelValue"]);

const prevValue = ref(props.modelValue);
function emitValue(e) {
  let value = e.target.value;

  const onlyInt = /[^\d]+/g;
  const noLeadingZero = /^0+([1-9][0-9]*)$/g;
  const moreThanOneZero = /^0+$/g;

  const replaceNonInt = /[^\d\.]+/g;
  const replaceStartWithPeriod = /^\./g;
  const replaceExtraPeriod = /\.{2,}/g;
  const replaceExtraDec = /^(\d+\.)(\d{2}).*/g;

  if (props.isPercentage && value > 100) {
    value = prevValue.value;
  } else if (props.isPercentage && value == 100) {
    value = 100;
  } else if (value > Number.MAX_SAFE_INTEGER) {
    value = prevValue.value;
  }

  if (props.isWhole) {
    value = `${value}`
      .replace(noLeadingZero, "$1")
      .replace(moreThanOneZero, "0")
      .replace(onlyInt, "");
  } else {
    value = `${value}`
      .replace(noLeadingZero, "$1")
      .replace(moreThanOneZero, "0")
      .replace(replaceNonInt, "")
      .replace(replaceStartWithPeriod, "")
      .replace(replaceExtraPeriod, ".")
      .replace(replaceExtraDec, "$1$2");
  }

  if (isNaN(value)) {
    value = 0;
  }

  prevValue.value = value;
  e.target.value = value;

  emit(
    "update:modelValue",
    props.inputType == "number" ? Number(value) : `${value}`
  );
}
</script>

<template>
  <div class="input-group">
    <input
      type="text"
      class="form-control"
      :class="props.customClass"
      :value="props.modelValue"
      @input="emitValue"
      :placeholder="props.placeholder"
    />
  </div>
</template>
